import Checkout from '../components/Checkout/Checkout';
import '../components/Checkout/Checkout.css';

const CheckoutPage = () => {
  return (
    <Checkout />
  );
};

export default CheckoutPage;
